import { createVersion } from '../factories'

export const version = createVersion(() => ({
  __REHAJE_COMMIT_HASH__,
  __REHAJE_PACKAGE__,
  __REHAJE_VERSION__
}))
